var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 3.00098C20.2404 3.00098 20.9997 3.75964 21 4.6875V19.3125C21 20.2406 20.2406 21 19.3125 21H4.6875C3.75942 21 3 20.2408 3 19.3125V4.6875C3.00027 3.75964 3.75958 3.00098 4.6875 3.00098H19.3125ZM12.2666 14.0479C12.2353 14.8836 11.5472 15.5547 10.7041 15.5547C10.4422 15.5546 10.1957 15.4893 9.97852 15.375C9.48031 15.1128 9.13872 14.5902 9.13867 13.9893C9.13867 13.1261 9.84112 12.424 10.7041 12.4238C10.8652 12.4238 11.0199 12.4506 11.166 12.4961V10.5947C11.0147 10.574 10.8608 10.5605 10.7041 10.5605C8.81404 10.5607 7.27637 12.099 7.27637 13.9893C7.27641 15.1488 7.85611 16.1753 8.74023 16.7959C9.29682 17.1867 9.97411 17.4169 10.7041 17.417C12.5942 17.417 14.1318 15.8792 14.1318 13.9893V10.2041C14.8623 10.7283 15.7579 11.0371 16.7236 11.0371V9.1748C16.2037 9.1748 15.7191 9.02071 15.3125 8.75586C14.729 8.37554 14.3082 7.76616 14.1768 7.05664C14.1485 6.90346 14.1318 6.74544 14.1318 6.58398H12.2695L12.2666 14.0479Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.b2ac70f05e5f0801dfc95db31c5d0c32.svg";
export { ForwardRef as ReactComponent };